import { Box, Heading, SimpleGrid, VStack, Text } from '@chakra-ui/react';

const BioSection = () => (
  <Box py={10} px={6} bg="pastelYellow">
    <Heading textAlign="center" fontSize="2xl" color="white" mb={6}>
      Professional Highlights
    </Heading>
    <SimpleGrid columns={[1, 2, 3]} spacing={10}>
      {/* Card 1 */}
      <VStack
        bg="white"
        p={6}
        borderRadius="lg"
        boxShadow="md"
        _hover={{ transform: 'scale(1.05)', boxShadow: 'xl' }}
        transition="all 0.3s ease-in-out"
        textAlign="center"
      >
        <Text fontWeight="bold" fontSize="lg" color="gray.700">
          Senior Account Executive
        </Text>
        <Text fontSize="sm" color="gray.500">
          Over 30 years in Christian media and consulting.
        </Text>
      </VStack>

      {/* Card 2 */}
      <VStack
        bg="white"
        p={6}
        borderRadius="lg"
        boxShadow="md"
        _hover={{ transform: 'scale(1.05)', boxShadow: 'xl' }}
        transition="all 0.3s ease-in-out"
        textAlign="center"
      >
        <Text fontWeight="bold" fontSize="lg" color="gray.700">
          Women’s Ministry Leader
        </Text>
        <Text fontSize="sm" color="gray.500">
          Mentoring and teaching women to grow spiritually.
        </Text>
      </VStack>

      {/* Card 3 */}
      <VStack
        bg="white"
        p={6}
        borderRadius="lg"
        boxShadow="md"
        _hover={{ transform: 'scale(1.05)', boxShadow: 'xl' }}
        transition="all 0.3s ease-in-out"
        textAlign="center"
      >
        <Text fontWeight="bold" fontSize="lg" color="gray.700">
          Community Advocate
        </Text>
        <Text fontSize="sm" color="gray.500">
          Supporting women in need as a Client Care Advocate.
        </Text>
      </VStack>
    </SimpleGrid>
  </Box>
);

export default BioSection;
